import { useCallback, useState } from 'react';

export interface PageState<T> {
  data: T;
  updateState: (updates: Partial<T>) => void;
  resetState: () => void;
}

export function usePageState<T extends object>(initialState: T): PageState<T> {
  const [state, setState] = useState<T>(initialState);

  const updateState = useCallback((updates: Partial<T>) => {
    setState((prev) => ({ ...prev, ...updates }));
  }, []);

  const resetState = useCallback(() => {
    setState(initialState);
  }, [initialState]);

  return { data: state, updateState, resetState };
}

export default usePageState;

